import { Box, Button, Fade, Stack, Typography } from "@mui/material";
import { StyledSpinner } from "src/shared/components/StyledSpinner";
import WhiteCard from "src/shared/components/WhiteCard";
import oralBottle from "src/assets/oral-bottle.png";
import { useTranslation } from "react-i18next";
import { useProduct } from "src/context/ProductProvider";
import { useSubmitAnswers } from "src/hooks/useSubmitAnswers";
import { useCallback, useEffect, useRef, useState } from "react";

const SupplementsProgressProjection = () => {
  const { nextQuestion } = useSubmitAnswers();
  const slideContainerRef = useRef<HTMLDivElement>(null);
  const [fadeLoader, setFadeLoader] = useState<boolean>(false);
  const [fadeHeader, setFadeHeader] = useState<boolean>(false);
  const [switchVisual, setSwitchVisual] = useState<boolean>(false);
  const { t } = useTranslation();
  const slug = useProduct((p) => p.slug);
  const page = `progress-projection.${slug}`;

  useEffect(() => {
    const visualTimeout = setTimeout(() => {
      setSwitchVisual(true);
    }, 5000);

    return () => clearTimeout(visualTimeout);
  }, []);

  useEffect(() => {
    const loaderTimeout = setTimeout(() => setFadeLoader(true), 200);
    const headerTimeout = setTimeout(() => setFadeHeader(true), 1000);

    return () => {
      clearTimeout(loaderTimeout);
      clearTimeout(headerTimeout);
    };
  }, []);

  const handleNext = useCallback(() => nextQuestion(), [nextQuestion]);

  return (
    <Stack gap="20px">
      <Stack gap="20px" onClick={handleNext} role="animated-stack">
        <Fade in={!switchVisual} unmountOnExit mountOnEnter>
          <WhiteCard
            spacing={4}
            overflow="hidden"
            height="400px"
            sx={{
              borderRadius: "30px",
              background: `
            linear-gradient(
              180deg,
               rgba(255, 255, 255, 0) 0.31%,
               rgba(255, 255, 255, 0.36) 99.69%
            ),
           #00B6B9
          `,
            }}
            alignItems="center"
          >
            <Stack
              alignItems="center"
              gap={2}
              py={3}
              overflow="hidden"
              ref={slideContainerRef}
            >
              <Fade in={fadeLoader}>
                <StyledSpinner />
              </Fade>
              <Fade in={fadeHeader}>
                <Typography
                  variant="h3"
                  textAlign="center"
                  fontWeight={700}
                  color="#fff"
                >
                  {t(`${page}.spinner`)}
                </Typography>
              </Fade>
            </Stack>
          </WhiteCard>
        </Fade>
        <Fade in={switchVisual} timeout={1000} unmountOnExit mountOnEnter>
          <Stack gap={2}>
            <Typography variant="h3">{t(`${page}.header`)}</Typography>
            <Typography variant="subtitle1">
              {t(`${page}.description`)}
            </Typography>
            <WhiteCard
              sx={{
                background: "linear-gradient(180deg, #F8F8F8 0%, #FBF9F7 100%)",
                borderRadius: "30px",
                boxShadow: "none",
              }}
            >
              <Box
                component={"img"}
                src={oralBottle}
                width={214}
                ml="auto"
                mr="auto"
                alt="Bottle of cream"
              />
            </WhiteCard>
            <Typography variant="h5">{t(`${page}.subheader`)}</Typography>
            <Typography variant="subtitle1">{t(`${page}.footer`)}</Typography>
          </Stack>
        </Fade>
      </Stack>
      {switchVisual ? (
        <Button variant="contained" onClick={handleNext}>
          {t("questions.submit")}
        </Button>
      ) : null}
    </Stack>
  );
};

export default SupplementsProgressProjection;
